import * as React from "react"
import { formatPercentage } from "@ui-seeker/utils/"

import { CategoryText } from "../@components"
import { adminScrapingDataReviewPercentageData } from "../../../@signals"


// Igual que la columna de Description: aquí se dice **si hay** rich content text, no cuál es. El
// texto llega en `/show-details`; la bandera `hasRichContentText` la calcula SQL sobre
// `DIPI_PRODUCT_PAGE_DETAILS` y es la misma que cuenta el porcentaje de la cabecera.
export default function richContentTextColumn() {
	return {
		name: 'hasRichContentText',
		label: `Rich Content Text (${formatPercentage(adminScrapingDataReviewPercentageData.value["percentageRichContentText"], { decimals: 2 })})`,
		options: {
			display: false,
			setCellHeaderProps: () => ({
                sx: {
                    textAlign: "center",
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			setCellProps: () => ({
                sx: {
                    textAlign: "center",
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			filterType: "checkbox",
			customBodyRowRender: value => <CategoryText
				label={value ? "yes" : "no"}
				color={value ? "success" : "error"}
			/>
		}
	}
}